<template>
  <div>
    <validation-observer v-slot="{ invalid }">
      <v-form>
        <v-card>
          <v-card-title>品目</v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="6">
                <p class="mb-0">
                  親品目
                </p>
                <tree-select
                  v-model="item.parent"
                  :multiple="false"
                  :clearable="true"
                  :options="items"
                  :show-count="true"
                  :searchable="true"
                  placeholder="選択してください"
                >
                  <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }" :class="labelClassName">
                    {{ node.label }}
                    <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
                  </label>
                </tree-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="コード"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="item.code"
                    :error-messages="errors"
                    label="コード"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="6">
                <validation-provider
                  v-slot="{ errors }"
                  rules="required"
                  name="名称"
                  class="requiredMark"
                >
                  <v-text-field
                    v-model="item.name"
                    :error-messages="errors"
                    label="名称"
                    hide-details="auto"
                    persistent-placeholder
                    required
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              color="primary"
              :disabled="invalid"
              @click="registerButtonClickEvent"
            >
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </div>
</template>

<script>
import TreeSelect from '@riophae/vue-treeselect'
export default {
  name: 'AdminMasterItemForm',
  components: {
    TreeSelect
  },
  mixins: [],
  props: {
  },
  data () {
    return {
      selectItem: null,
      items: [
        {
          id: 1,
          label: '燃え殻',
          code: '0100000',
          children: [
            {
              id: 2,
              label: '焼却灰',
              code: '0110000',
            },
            {
              id: 3,
              label: '廃カーボン・活性炭',
              code: '0120000',
            },
          ],
        },
        {
          id: 4,
          label: '汚泥（泥状のもの）',
          code: '',
          children: [
            {
              id: 5,
              label: '有機性汚泥',
              code: '',
            },
            {
              id: 6,
              label: '無機性汚泥',
              code: '',
            }
          ]
        },
        {
          id: 7,
          label: '廃油',
          code: '',
          children: [
            {
              id: 8,
              label: '一般廃油',
            },
            {
              id: 9,
              label: '廃溶剤',
            },
            {
              id: 10,
              label: '固形油',
            },
            {
              id: 11,
              label: '油でい',
            },
          ]
        }
      ],
      item: {
        id: null,
        name: null,
        code: null,
        parent: null,
      }
    }
  },
  computed: {
  },
  created() {
    if (this.$route.params.id) {
      this.item = {
        id: 2,
        name: '焼却灰',
        code: '0110000',
        parent: 1,
        hierarchy: '燃え殻',
        created_at: 1633314402,
        updated_at: 1633314402,
      }
    }
  },
  methods: {
    registerButtonClickEvent () {
      this.$router.push({name: 'AdminMasterItems'})
    }
  }
}
</script>

<style scoped>

</style>
